var _circle, _rect, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmergency = function SvgEmergency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.162,
    cy: 32.029,
    r: 29.162,
    stroke: "#BC5C41",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.27,
    y: 13.852,
    width: 6.492,
    height: 25.969,
    rx: 2,
    fill: "#BC5C41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.516,
    cy: 46.965,
    r: 3.246,
    fill: "#BC5C41"
  })));
};
export default SvgEmergency;